import React from "react";
import RaceLeagueBox from "./RaceLeagueBox";
// import "./RaceCards.scss";

const RaceCards = ({ data = [], sport, dataClient, dataPath, websiteBaseUrl }) => {
  return (
    <div className="leg_wrp">
      {data?.length > 0 ? data?.map((item, index) => {
        return (
          <div className="leg_box" key={index}>
            <RaceLeagueBox league={item} sport={sport} dataClient={dataClient} dataPath={dataPath} websiteBaseUrl={websiteBaseUrl} />
          </div>
        );
      }) : null}
    </div>
  );
};

export default RaceCards;
